import React, { Component } from 'react';
import { getCurrentFunctionName } from '../../performanceModeManager';
import { Card } from '@material-ui/core';
import TableWithPagination from '../Table/TableWithPagination';
import { loadAffair, setFilteredAndSortedAffairs } from '../../redux/affair/affairActions'
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS } from '../../redux/authorizedApps/authorizedAppsConstants';

class AffairsAsTable extends Component {

    getTableTrProps(state, rowInfo) {
        if (rowInfo && rowInfo.row) {
            return {
                onClick: this.loadAffair.bind(this, rowInfo.row._original),
                style: {
                    cursor: 'pointer'
                },
            }
        } else {
            return {}
        }
    }

    loadAffair(affair) {
        this.props.loadAffair(affair);
        this.props.history.push("/affairs/affair");
        this.props.globalContainer.current.scrollTop = 0
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return (
            <Card>
                <TableWithPagination
                    ref={this.reactTable}
                    data={this.props.filteredAndSortedAffairs.filter((a) => !a.deleted)}
                    columns={this.props.columns} manual getTrProps={this.getTableTrProps.bind(this)}
                    pages={Math.ceil(this.props.tableState.nbTotalResults[MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS] / this.props.tableState.pageSize)}
                    onFetchData={(state) => {
                        let tableState = {
                            pageSize: state.pageSize,
                            pageNumber: state.page,
                            orderBy: state.sorted.length > 0 ? state.sorted[0].id : "",
                            descOrder: state.sorted.length > 0 ? state.sorted[0].desc : false
                        }

                        this.props.setFilteredAndSortedAffairs(this.props.affairs, tableState, this.props.activeUser,
                            this.props.sites.selectedSite, this.props.sites.sites, this.props.tableState.nbTotalResults);
                    }}
                />
            </Card>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        affairs: state.affairs,
        activeUser: state.activeUser,
        tableState: state.tableState,
        sites: state.sites,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilteredAndSortedAffairs: (affairsFilters, tableState, user, customerSiteId, allSites, nbTotalResults) =>
            dispatch(setFilteredAndSortedAffairs(affairsFilters, tableState, user, customerSiteId, allSites, nbTotalResults)),
        loadAffair: (affair) => dispatch(loadAffair(affair)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(AffairsAsTable);
